(function () {
  'use strict';

  var hasItems = window.__cartItemCount && window.__cartItemCount > 0;
  var mensajesConCarrito = ['¡Volvé! 👋', 'Tu carrito te espera 🛒', 'Estás a un click 🛍️', 'No te olvides de tu compra'];
  var mensajesSinCarrito = ['¡Volvé! 👋', 'Te estamos esperando 👀', 'Seguí mirando 🛍️', 'No te vayas todavía'];
  var mensajes = hasItems ? mensajesConCarrito : mensajesSinCarrito;
  var tituloOriginal = document.title;
  var intervalo = null;
  var indice = 0;

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      indice = 0;
      intervalo = setInterval(function () {
        document.title = mensajes[indice % mensajes.length];
        indice++;
      }, 2000);
    } else {
      clearInterval(intervalo);
      document.title = tituloOriginal;
    }
  });
})();
